import hblogin from "../../api/axios";
import hbscan from "../../api/hbscan";
import IProfile from "../../models/profile";
import IProfileFloor from "../../models/profileFloor";
import IEditProfileRequest from "../../models/requests/profile/editProfileRequest";
import ITask from "../../models/task";
import Auth from "../auth/AuthService";

class ProfileService {
    GetFloorsAndProfileByBuilding = async (buildingId: number) => {
        const url = "/api/hblogin/profile/GetFloorsAndProfileByBuilding";
        return (
            (
                await hblogin.get<IProfileFloor>(url, {
                    headers: { Authorization: Auth.guid },
                    params: { buildingId },
                })
            ).data || []
        );
    };
    async GetProfiles() {
        const URI = "/api/hblogin/profile/GetProfiles";

        return (
            (
                await hblogin.get<IProfile[]>(URI, {
                    headers: { Authorization: Auth.guid },
                })
            ).data || []
        );
    }

    PostProfile = async (profile: IProfile) => {
        const URL = `/api/hblogin/profile/PostProfile`;

        return (
            await hblogin.post<number>(URL, JSON.stringify(profile), {
                headers: { Authorization: Auth.guid },
            })
        ).data;
    };

    PutProfile = async (profile: IEditProfileRequest) => {
        const URL = `/api/hblogin/profile/PutProfile`;

        return (
            await hblogin.put(URL, JSON.stringify(profile), {
                headers: { Authorization: Auth.guid },
            })
        ).data;
    };

    GetTasks = async () => {
        const URI = `api/hbscan/task/GetTasks`;
        return (
            await hbscan.get<ITask[]>(URI, {
                headers: {
                    Authorization: Auth.guid,
                },
            })
        ).data;
    };

    GetTasksByCompanyId = async (companyId: number) => {
        const URI = `api/hbscan/task/GetTasks`;
        return (
            await hbscan.get<ITask[]>(URI, {
                params: {
                    companyId,
                },
                headers: {
                    Authorization: Auth.guid,
                },
            })
        ).data;
    };
    async GetProfilesByBuildingId(buildingId: number) {
        const URI = "/api/hblogin/profile/GetProfilesTasksByBuildingId";

        return (
            await hblogin.get<IProfile[]>(URI, {
                headers: { Authorization: Auth.guid },
                params: { buildingId },
            })
        ).data;
    }

    async GetTasksProfileId(profileId: number) {
        const URI = "/api/hbscan/ProfileTask/GetTasksProfileId";

        return (
            await hbscan.get<ITask[]>(URI, {
                headers: { Authorization: Auth.guid },
                params: { profileId },
            })
        ).data;
    }

    async GetProfilesByPropertyGroups() {
        const URI = "/api/hblogin/profile/GetProfilesByPropertyGroups";

        return (
            await hblogin.get<IProfile[]>(URI, {
                headers: { Authorization: Auth.guid },
            })
        ).data;
    }
}

const profileService = new ProfileService();

export default profileService;
